<template>
  <div class="c-home">
    <the-topbar></the-topbar>

    <div class="c-section">
      <div class="c-section-content">
        <the-video-player :src="data[1].collection_items[0].fields" v-if="data" :currentTime="currentTime"></the-video-player>
        <the-bookmarks :content="data[1].collection_items" v-if="data" @update-timecode="updateTimecode"></the-bookmarks>
      </div>
      <div class="c-section-sidebar">
        <the-lang-picker :langs="data[0].content.version_info" v-if="data"></the-lang-picker>
      </div>
    </div>

    <the-modal></the-modal>
    <the-footer></the-footer>
  </div>
</template>

<script>
import TheTopbar from '@/components/TheTopbar.vue';
import TheFooter from '@/components/TheFooter.vue';
import TheLangPicker from '@/components/TheLangPicker.vue';
import TheVideoPlayer from '@/components/TheVideoPlayer.vue';
import TheBookmarks from '@/components/TheBookmarks.vue';
import TheModal from '@/components/TheModal.vue';

import fetchData from '@/api';

export default {
  name: 'home',

  data() {
    return {
      data: null,
      currentTime: '0',
    };
  },

  components: {
    'the-topbar': TheTopbar,
    'the-footer': TheFooter,
    'the-lang-picker': TheLangPicker,
    'the-video-player': TheVideoPlayer,
    'the-bookmarks': TheBookmarks,
    'the-modal': TheModal,
  },

  beforeRouteUpdate(to, from, next) {
    next();
    fetchData(this.$route.params.lang || 'nor-NO').then((res) => { this.data = res.main; });
  },

  created() {
    fetchData(this.$route.params.lang || 'nor-NO').then((res) => { this.data = res.main; });
  },

  updated() {
    if (this.$route.params.lang === 'nor-NO' || this.$route.params.lang === 'nno-NO' || !this.$route.params.lang) {
      document.title = 'd-bok hjelp';
    } else {
      document.title = 'd-bok help';
    }
  },

  methods: {
    updateTimecode(e) {
      this.currentTime = e;
    }
  },
};
</script>

<style lang="scss">
.c-section {
  padding: 50px 20px;
  display: flex;
  flex-direction: column-reverse;
}

.c-section-content {
  width: 100%;
  background: #000;
  padding: 10px;
  border-radius: 15px;
  margin-right: 30px;
}

.c-section-sidebar {
  width: 100%;
  margin-bottom: 50px;
}

@media (min-width: 900px) {
  .c-section {
    max-width: 1400px;
    margin: 0 auto;
    flex-direction: row;
  }

  .c-section-content {
    width: 80%;
    background: #000;
    padding: 10px;
    border-radius: 15px;
    margin-right: 30px;
  }

  .c-section-sidebar {
    margin-bottom: 0;
    width: 20%;
  }
}
</style>
